export default __webpack_public_path__ + "static/media/EFBET-logo.2a83a73a.png";